import getColour from '@lendi-ui/commons/colours';

import { FIELD_PATHS } from '@funnels/constants';
import { Body } from '@funnels/ui-components';
import { validateInclusiveNumberRanges } from '@funnels/utils';

import { NumericalInputField } from '../../Fields';
import { FunnelViewProps } from '../types';

interface FinancialSituationRetirementAgeTeamViewProps extends FunnelViewProps {
  financialSituationIndex: number;
}

export const FinancialSituationRetirementAgeTeamView = (props: FinancialSituationRetirementAgeTeamViewProps) => {
  const { financialSituationIndex } = props;

  return (
    <NumericalInputField
      name={FIELD_PATHS.FINANCIAL_SITUATION_RETIREMENTDETAILS_AGE(financialSituationIndex)}
      validate={validateInclusiveNumberRanges(18, 99, true)}
      placeholder={'Age'}
      isOptional={false}
      maxLength={2}
      maxValue="99"
      after={
        <Body color={getColour('text', 'subtle')} mr="xs" size="xs">
          YEARS
        </Body>
      }
    />
  );
};
